import type {
  Resolvers,
  UndoRedoCommand,
  UndoRedoCommandSet,
} from '../../../../generated';
import { MAX_STACK_SIZE, undoRedoCommandMap } from '../state';

export const resolvers: Resolvers = {
  Mutation: {
    addUndoCommand: (_, vars) => {
      const commandMap = undoRedoCommandMap.get('default');
      const undoCommand: UndoRedoCommand = {
        type: 'UNDO',
        values: {
          __typename: 'SetAssetFieldValueInputValues',
          ...vars.undoInput?.setAssetFieldValueInput,
        },
      };
      const redoCommand: UndoRedoCommand = {
        type: 'REDO',
        values: {
          __typename: 'SetAssetFieldValueInputValues',
          ...vars.redoInput?.setAssetFieldValueInput,
        },
      };
      const commandSet: UndoRedoCommandSet = {
        undo: undoCommand,
        redo: redoCommand,
      };
      const updatedCommandMap = {
        ...commandMap,
        undos: [commandSet, ...commandMap.undos].slice(0, MAX_STACK_SIZE),
        activeCommand: null,
      };
      undoRedoCommandMap.set('default', updatedCommandMap);
      return null;
    },
  },
};
